import React, { useState } from 'react';
import HongButton from '../comm/HongButton';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import './StoreBookModal.scss';

const StoreBookModal = ({ 
  isOpen,
  isEditMode = false,
  formData, 
  onChange, 
  onSubmit, 
  onCancel 
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  if (!isOpen) return null;

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      // 파일명을 imgFileName에 자동 입력
      onChange({ target: { name: 'imgFileName', value: file.name } });
    }
  };

  // const handlePriceChange = (e) => {
  //   const value = e.target.value;
  //   // 숫자만 입력 가능
  //   if (value === '' || /^\d+$/.test(value)) {
  //     onChange(e);
  //   }
  // };

  const handleSubmitWithUpload = async () => {
    // 이미지 파일이 선택되어 있으면 먼저 업로드
    if (selectedFile) {
      try {
        const folder = 'public/storeBook';
        const expireSec = 600;
        
        // 타임스탬프 생성 (예: 20250429123045)
        const timestamp = new Date().toISOString().replace(/[-:T.Z]/g, '').slice(0, 14);
        const imgFileName2 = `${timestamp}_${selectedFile.name}`;

        fnc.sendAxios('/generate-upload-url', {
          fileName: imgFileName2, 
          fileType: selectedFile.type,
          folder: folder, 
          sec: expireSec
        }, async (presignedRes) => {
          if (presignedRes) {
            const { url, key } = presignedRes;
            
            // presigned URL로 S3에 직접 파일 PUT
            await fncS4.axiosPutFile(url, selectedFile);
            
            // imgFileName2를 포함하여 등록
            onChange({ target: { name: 'imgFileName2', value: imgFileName2 } });
            
            // 업로드 완료 후 등록 진행
            setTimeout(() => {
              onSubmit(imgFileName2);
            }, 100);
          } else {
            alert('이미지 업로드 실패');
          }
        });
      } catch (err) {
        console.error('업로드 중 오류 발생:', err);
        alert('이미지 업로드 중 오류가 발생했습니다.');
      }
    } else {
      // 이미지 없이 등록
      onSubmit();
    }
  };

  //================================렌더링 부분
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>{isEditMode ? '교재 수정' : '새 교재 등록'}</h3>
        <div className="form-group">
          <label>*카테고리 코드</label>
          <input 
            type="text" 
            name="pCode" 
            value={formData.pCode}
            onChange={onChange}
            disabled
          />
        </div>
        <div className="form-group">
          <label>*교재 코드</label>
          <input 
            type="text" 
            name="code" 
            value={formData.code}
            onChange={onChange}
          />
        </div>

        <div className="form-group">
          <label>*본사 교재코드</label>
          <input 
            type="text" 
            name="kuesbBookCode" 
            value={formData.kuesbBookCode}
            onChange={onChange}
           />
        </div>

        <div className="form-group">
          <label>*학년</label>
          <input 
            type="text" 
            name="grade" 
            value={formData.grade}
            onChange={onChange}
          />
        </div>
        <div className="form-group">
          <label>*제목</label>
          <input 
            type="text" 
            name="title" 
            value={formData.title}
            onChange={onChange}
          />
        </div>

        <div className="form-group">
          <label>*내용</label>
          <textarea 
            name="content" 
            value={formData.content}
            onChange={onChange}
            rows="1"
          />
        </div>

        <div className="form-group">
          <label>*출판사</label>
          <input 
            type="text" 
            name="publisher" 
            value={formData.publisher}
            onChange={onChange}
          />
        </div>
        {/* <div className="form-group">
          <label>*가격</label>
          <input 
            type="text" 
            name="price" 
            value={formData.price}
            onChange={handlePriceChange}
            placeholder="숫자만 입력"
          />
        </div> */}
        <div className="form-group">
          <label>*이미지 선택</label>
          <div className="file-upload-container">
            <input 
              type="file"
              accept="image/*"
              onChange={handleFileSelect}
              className="file-input"
            />
            {selectedFile && (
              <div className="file-info">
                선택된 파일: {selectedFile.name}
              </div>
            )}
          </div>
        </div>
        <div className="form-group">
          <label>이미지 파일명</label>
          <input 
            type="text" 
            name="imgFileName" 
            value={formData.imgFileName}
            onChange={onChange}
            placeholder="파일 선택 시 자동 입력됨"
            readOnly
          />
        </div>
       
      
        <div className="modal-buttons">
          <HongButton 
            className="btn h-btn-blue"
            iconType={'save'}
            onClick={handleSubmitWithUpload}
          >
            {isEditMode ? '수정' : '등록'}
          </HongButton>
          <HongButton 
            className="btn h-btn-white"
            iconType={'cancel'}
            onClick={onCancel}
          >
            취소
          </HongButton>
        </div>
      </div>
    </div>
  );
};

export default StoreBookModal;
